import { render, staticRenderFns } from "./ListagemAplicacoesPorLinha.vue?vue&type=template&id=2923f646&scoped=true"
import script from "./ListagemAplicacoesPorLinha.vue?vue&type=script&lang=js"
export * from "./ListagemAplicacoesPorLinha.vue?vue&type=script&lang=js"
import style0 from "./ListagemAplicacoesPorLinha.vue?vue&type=style&index=0&id=2923f646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923f646",
  null
  
)

export default component.exports